// extracted by mini-css-extract-plugin
export default {"ContactLinks":"ContactLinks_ContactLinks__NzftL"};